export enum SubcategoryTypeEnum {
  starProduct = 'starProduct',
  previewArticle = 'previewArticle',
  linkList = 'linkList',
  defaultLinkList = 'defaultLinkList',
  highlightedLinks = 'highlightedLinks'
}
